<template>
  <div class="inactive" v-if="city.status === 'inactive'">
    <div class="infos">
      <img src="../assets/images/logos/Logo.png">
      <p>Desculpe, infelizmente sua cidade ainda não está participando do Quero Minha Cidade Melhor, clique abaixo para solicitar.</p>
      <a @click="iWant()" v-if="!asked">Quero minha cidade!</a>
      <p v-if="asked">Obrigado, sua solicitação já foi enviada.</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['city'],

  data() {
    return {
      asked: localStorage.getItem('asked'),
      loading: false,
    };
  },

  methods: {
    iWant() {
      if (!this.loading) {
        this.loading = true;
        this.db.collection('askFor')
          .add(this.city)
          .then(() => {
            localStorage.setItem('asked', true);
            this.asked = true;
            this.loading = false;

            this.bus.$emit('alert', {
              status: 'success',
              message: 'Sua cidade foi solicitada com sucesso, aguarde a inclusão.',
            });
          })
          .catch(() => {
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .inactive {
    width: 80%;
    margin: auto;

    .infos {
      text-align: center;

      img {
        display: block;
        margin: auto;
        max-width: 200px;
        width: 100%;
      }

      p {
        font-size: 16px;
        max-width: 800px;
        display: block;
        margin: auto;
        margin-top: 30px;
        margin-bottom: 50px;
      }

      a {
        font-size: 24px;
        border-bottom: 2px solid #ccc;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
</style>
